import SendCodeForm from './SendCodeForm';
export default SendCodeForm;